/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  // ActionTDClasses,
  // ActionTHClasses,
  API,
  defaultLimitPagination,
  fileUpload,
  get,
  paymentMethods,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import { debounce } from "lodash";
import MainBody from "../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../components/Pagination";
import sortCaret from "../../components/SortCaret";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { LucidePlusCircle } from "lucide-react";
import {
  formatAccountNumber,
  formatBSBNumber,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
  MaxLimit,
  pastFinancialdate,
} from "../../lib/Misc";
import AddEditReceipt from "./AddEditReceipt";
import ReceiptActionButton from "./ReceiptActionButton";
import Confirmation from "../../components/Confirmation";
import { Button } from "../../components/ui/button";
import AdditionalDocumentEmailModal from "../../components/Email/AdditionalDocumentEmailModal";
import { useTrust } from "../../lib/context/TrustContext";
import CommonFilters from "../../components/CommonFilters";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import ExpandReceipt from "./ExpandReceipt";
import { useMediaQuery } from "../../components/use-media-query";
import moment from "moment";
import { CalendarDatePicker } from "../../components/CalendarDatePicker";
// import CustomTooltip from "../../components/CustomTooltip";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { DateInputPicker } from "../../components/DateInputPicker";
import { cn } from "../../lib/utils";
import UploadReceipt from "./UploadReceipt";
import { LawyerConditon } from "../../lib/PermissionConditions";
import { Formik } from "formik";
import { NumericFormat } from "react-number-format";
import { receiptRefundSchema } from "../../lib/Validation";
import RefundReceiptHistory from "./RefundReceiptHistory";
import SearchSelect from "../../components/SearchSelect";

const Receipts = ({ expandList = false, initialSubAssetId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { organizationData } = useOrganization();
  const formikRef = useRef(null);

  // const isDesktop = useMediaQuery("(min-width: 768px)");
  const isBigDesktop = useMediaQuery("(min-width: 1024px)");

  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [receiptList, setReceiptsList] = useState([]);
  const [receiptLastDate, setReceiptLastDate] = useState([]);
  const [loading, setLoading] = useState(false);

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const { trustId } = useTrust();

  const [receiptId, setReceiptId] = useState(null);
  const [receiptItem, setReceiptItem] = useState(null);
  const [showAddEditReceipt, setShowAddEditReceipt] = useState(false);
  const [showUndo, setShowUndo] = useState(false);
  const [showSendEmail, setShowSendEmail] = useState(false);
  const [files, setFiles] = useState([]);
  const [mailData, setMailData] = useState(false);

  const [vendorId, setVendorId] = useState();
  const [assetId, setAssetId] = useState();
  const [contactId, setContactId] = useState();
  const [contractId, setContractId] = useState();
  const [subAssetId, setSubAssetId] = useState(initialSubAssetId);
  const [reversedId, setReversedId] = useState();
  const [refundId, setRefundId] = useState();
  const [disposedId, setDisposedId] = useState();

  const [showRefund, setShowRefund] = useState(false);
  const [showUse, setShowUse] = useState(false);
  const [showRefundHistory, setShowRefundHistory] = useState();

  // const [refundDate, setRefundDate] = useState(new Date());
  // const [allocateDate, setAllocateDate] = useState(new Date());

  const [showDelete, setShowDelete] = useState(false);

  const toggleShowRefundHistory = () => {
    setShowRefundHistory(!showRefundHistory);
  };

  const toggleShowDelete = () => {
    setShowDelete(!showDelete);
  };

  const toggleShowRefund = () => {
    setShowRefund(!showRefund);
  };

  const toggleShowUse = () => {
    setShowUse(!showUse);
  };

  const fromDate = query.get("from")
    ? new Date(query.get("from")?.split("-").reverse().join("-"))
    : "";
  const toDate = query.get("to")
    ? new Date(query.get("to")?.split("-").reverse().join("-"))
    : "";

  const [selectedDateRange, setSelectedDateRange] = useState(
    fromDate && toDate
      ? {
          from: fromDate,
          to: toDate,
        }
      : {
          from: pastFinancialdate[0],
          to: pastFinancialdate[1],
        },
  );

  const fetchABAReceipt = async (receiptId, action) => {
    try {
      setLoading(true);
      const { data } = await get(`${API.GET_RECEIPT}/${receiptId}/${action}`);
      setMailData(data?.data);
      handleSendEmail();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSendEmail = async (id) => {
    if (showSendEmail) {
      setFiles([]);
    } else {
      if (id) {
        await fetchABAReceipt(id, "email");
      }
    }
    setShowSendEmail(!showSendEmail);
    setReceiptId(id);
  };

  const PostDefaultMail = useCallback(async (id) => {
    if (id) {
      try {
        setLoading(true);
        await get(`${API.GET_RECEIPT}/${id}/email?send_email=1`);
        setShowSendEmail(false);
        fetchReceipts(limit, page);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (values) => {
    if (receiptId) {
      try {
        setLoading(true);
        const formData = new FormData();
        // formData.append("id", receiptId);
        formData.append("type", "receipt");
        formData.append("trust_id", trustId);
        for (const key in values) {
          if (key !== "ccChip" && key !== "bccChip") {
            if (key === "cc" || key === "bcc") {
              if (values[key]) {
                let valueData = values[key];
                for (
                  let valueIndex = 0;
                  valueIndex < valueData?.length;
                  valueIndex++
                ) {
                  formData.append(
                    `${key}[${valueIndex}]`,
                    valueData[valueIndex],
                  );
                }
              }
            } else {
              formData.append(key, values[key]);
            }
          }
        }
        files.forEach((file, index) => {
          formData.append(`attachments[${index}]`, file);
        });
        await fileUpload(`${API.SEND_EMAIL_DOCS}/${receiptId}`, formData);
        setShowSendEmail(false);
        fetchReceipts(limit, page);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const toggleShowAddEditReceipt = () => {
    if (showAddEditReceipt) {
      setReceiptId(null);
    }
    setShowAddEditReceipt(!showAddEditReceipt);
  };

  const toggleShowUndo = () => {
    if (showUndo) {
      setReceiptId(null);
    }
    setShowUndo(!showUndo);
  };

  const handleReceiptUndo = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("module", "receipt");
      formData.append("trust_id", trustId ? trustId : "");
      formData.append("ids[0]", receiptId);
      await fileUpload(`${API.JOURNAL_ENTRIES_UNDO}`, formData);
      setLoading(false);
      fetchReceipts(limit, page);
      toggleShowUndo();
    } catch (error) {
      setLoading(false);
    }
  };

  const handleReceiptRefund = async (type, values) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("refund", type);
      if (type === "1") {
        formData.append(
          "refund_date",
          values?.refund_date
            ? moment(values?.refund_date)?.format("DD-MM-YYYY")
            : "",
        );
        formData.append(
          "receipt_detail_id",
          values?.receipt_detail_id ? values?.receipt_detail_id : "",
        );
        formData.append(
          "refund_amount",
          values?.refund_amount
            ? Number(`${values?.refund_amount}`.replace(/,/g, ""))
            : "",
        );
      } else {
        // formData.append(
        //   "allocate_date",
        //   allocateDate ? moment(allocateDate)?.format("DD-MM-YYYY") : ""
        // );
      }

      formData.append("trust_id", trustId ? trustId : "");
      await fileUpload(`${API.RECEIPT_REFUND}/${receiptId}`, formData);
      setLoading(false);
      fetchReceipts(limit, page);
      if (type === "1") {
        toggleShowRefund();
      } else {
        toggleShowUse();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleReceiptDelete = async () => {
    try {
      setLoading(true);
      await fileUpload(`${API.RECEIPT_ARCHIVED}/${receiptId}`);
      setLoading(false);
      fetchReceipts();
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchReceipts = useCallback(
    async (passLimit, passPage) => {
      if (trustId) {
        try {
          setLoading(true);
          const { data } = await get(
            `${API.GET_RECEIPT}?limit=${
              passLimit ? passLimit : limit ? limit : defaultLimitPagination
            }&page=${passPage ? passPage : page ? page : 1}&search=${
              searchParam ? searchParam : ""
            }&sort_column=${sortField ? sortField : ""}&sort_order=${
              sortOrder ? sortOrder : ""
            }&trust_id=${trustId ? trustId : ""}&vendor_id=${
              vendorId ? vendorId : ""
            }&contact_id=${contactId ? contactId : ""}&asset_id=${
              assetId ? assetId : ""
            }&sub_asset_id=${subAssetId ? subAssetId : ""}&contract_id=${
              contractId ? contractId : ""
            }&is_reversed=${reversedId ? reversedId : ""}&is_refund=${
              refundId ? refundId : ""
            }&is_disposed=${disposedId ? disposedId : ""}&start_date=${
              moment(selectedDateRange?.from).format("DD-MM-YYYY")
                ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
                : ""
            }&end_date=${
              moment(selectedDateRange?.to).format("DD-MM-YYYY")
                ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
                : ""
            }`,
          );

          setLoading(false);
          setReceiptLastDate(data?.last_to_date);
          setLimit(data?.data?.per_page);
          setPage(data?.data?.current_page);
          setTotal(data?.data?.total);
          setFrom(data?.data?.from);
          setTo(data?.data?.to);
          const receiptList = data.data.data;
          setReceiptsList(receiptList);
          return data.data;
        } catch (error) {
          setLoading(false);
          setReceiptsList([]);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      assetId,
      contactId,
      contractId,
      searchParam,
      selectedDateRange?.from,
      selectedDateRange?.to,
      sortField,
      sortOrder,
      subAssetId,
      reversedId,
      disposedId,
      refundId,
      trustId,
      vendorId,
    ],
  );

  const receiptsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: receiptList[i]?.id,
        received_date: receiptList[i]?.received_date
          ? receiptList[i]?.received_date
          : "-",
        transaction_date: receiptList[i]?.transaction_date
          ? receiptList[i]?.transaction_date
          : "-",

        payment_method: receiptList[i]?.payment_method
          ? receiptList[i]?.payment_method == "5"
            ? "JE"
            : paymentMethods?.find(
                (item) => item.value === Number(receiptList[i]?.payment_method),
              )?.label
          : "-",
        receipt_number: receiptList[i]?.receipt_number
          ? receiptList[i]?.receipt_number
          : "-",
        invoice_number: receiptList[i]?.invoice_number
          ? receiptList[i]?.invoice_number
          : "-",
        amount: receiptList[i]?.original_amount ? (
          <b>${formatNumber(Number(receiptList[i]?.original_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        amount_exc: receiptList[i]?.total_amount_exc ? (
          <b>${formatNumber(Number(receiptList[i]?.total_amount_exc))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        tax_amount: receiptList[i]?.total_tax_amount ? (
          <b>${formatNumber(Number(receiptList[i]?.total_tax_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        bsb: receiptList[i]?.bsb ? formatBSBNumber(receiptList[i]?.bsb) : "-",
        account_number: receiptList[i]?.account_number
          ? formatAccountNumber(receiptList[i]?.account_number)
          : "-",
        description: receiptList[i]?.description
          ? receiptList[i]?.description
          : "-",
        vendor: receiptList[i]?.vendor
          ? formatSubcontractorName(receiptList[i]?.vendor)
          : "-",
        asset: receiptList[i]?.asset?.name ? receiptList[i]?.asset?.name : "-",
        sub_asset: receiptList[i]?.sub_asset?.name
          ? receiptList[i]?.sub_asset?.name
          : "-",
        contract: receiptList[i]?.contract
          ? receiptList[i]?.contract?.contract_number
          : "-",
        contact: receiptList[i]?.contact
          ? formatSubcontractorName(receiptList[i]?.contact)
          : "-",
        payeer:
          receiptList[i]?.payeer === 1
            ? receiptList[i]?.vendor
              ? `${formatSubcontractorName(receiptList[i]?.vendor)} - (${getModuleNamingBySlug(
                  organizationData,
                  "vendors",
                  "V",
                )?.charAt(0)})`
              : "-"
            : receiptList[i]?.contact
              ? `${formatSubcontractorName(receiptList[i]?.contact)} - (${getModuleNamingBySlug(
                  organizationData,
                  "contacts",
                  "C",
                )?.charAt(0)})`
              : "-",
        job: receiptList[i]?.ts_job?.code ? receiptList[i]?.ts_job?.code : "-",
        task: receiptList[i]?.ts_task?.code
          ? receiptList[i]?.ts_task?.code
          : "-",
        file_note: receiptList[i]?.file_note ? receiptList[i]?.file_note : "-",
        is_reversed: receiptList[i]?.is_reversed,
        is_refund: receiptList[i]?.is_refund,
        is_disposed: receiptList[i]?.is_disposed,
        archived: receiptList[i]?.archived,
        allocation_date: receiptList[i]?.allocation_date
          ? receiptList[i]?.allocation_date
          : "",
        refunded_date: receiptList[i]?.refunded_date
          ? receiptList[i]?.refunded_date
          : "",
        receiptData: receiptList[i]?.receipt_detail
          ? receiptList[i]?.receipt_detail
          : "",
        remaining_balance:
          receiptList[i]?.receipt_detail?.length > 0 ? (
            <b>
              $
              {formatNumber(
                Number(
                  receiptList[i]?.receipt_detail?.reduce(
                    (sum, item) => sum + Number(item?.remaining_balance || 0),
                    0,
                  ),
                ),
              ) || "0.00"}
            </b>
          ) : (
            <b>{"$0.00"}</b>
          ),
        status: (
          <span>
            <AnimatedTooltip
              title={
                receiptList[i].allocation_date
                  ? `Allocated - ${receiptList[i].allocation_date}`
                  : receiptList[i].refunded_date
                    ? `Refunded - ${receiptList[i].refunded_date}`
                    // : `Initial - ${receiptList[i].transaction_date}`
                    : ""
              }
            >
              {receiptList[i].allocation_date
                ? "Allocated"
                : receiptList[i].refunded_date
                  ? "Refunded"
                  : "Initial"}
            </AnimatedTooltip>
          </span>
        ),
        receipt_action: (
          <ReceiptActionButton
            id={receiptList[i]?.id}
            item={receiptList[i]}
            toggleShowRefundHistory={toggleShowRefundHistory}
            setReceiptId={setReceiptId}
            toggleShowUndo={toggleShowUndo}
            setReceiptItem={setReceiptItem}
            handleSendEmail={handleSendEmail}
            toggleShowRefund={toggleShowRefund}
            toggleShowUse={toggleShowUse}
            receiptAction={true}
            receipt_number={
              receiptList[i]?.receipt_number
                ? receiptList[i]?.receipt_number
                : "-"
            }
            setLoading={setLoading}
            trustId={trustId}
            toggleShowDelete={toggleShowDelete}
          />
        ),
        action: (
          <ReceiptActionButton
            id={receiptList[i]?.id}
            item={receiptList[i]}
            toggleShowRefundHistory={toggleShowRefundHistory}
            setReceiptId={setReceiptId}
            setReceiptItem={setReceiptItem}
            toggleShowUndo={toggleShowUndo}
            handleSendEmail={handleSendEmail}
            toggleShowRefund={toggleShowRefund}
            toggleShowUse={toggleShowUse}
            setLoading={setLoading}
            trustId={trustId}
            toggleShowDelete={toggleShowDelete}
          />
        ),
      });
    }
    return items;
  };

  const receipts = receiptsGenerator(receiptList?.length);

  const columns = !expandList
    ? [
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "received_date",
        //   text: "Received Date",
        //   sort: true,
        //   sortCaret,
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "transaction_date",
          text: "Transaction Date",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: cn(
            THClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          classes: cn(
            TDClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          // dataField: "contact",
          // text: `${getModuleNamingBySlug(
          //   organizationData?.organizationData,
          //   "contacts",
          //   "Customer",
          // )}`,
          dataField: "payeer",
          text: "Payer",
        },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "sub_asset",
        //   text: "Sub Asset",
        // },

        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "receipt_number",
          text: "Receipt Number",
          sort: true,
          sortCaret,
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "invoice_number",
          text: "Invoice Number",
          sort: true,
          sortCaret,
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "file_note",
          text: LawyerConditon(organizationData)
            ? "Matter Reference"
            : "File Note",
        },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "payment_method",
        //   text: "Payment Method",
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "amount",
          text: "Amount (Inc)",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "remaining_balance",
          text: "Remaining Balance",
        },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "amount_exc",
        //   text: "Amount (Exc)",
        // },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "tax_amount",
        //   text: "Tax",
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "status",
          text: "Status",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "receipt_action",
          text: "Receipt",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          // headerClasses: ActionTHClasses,
          // classes: (cell, row, rowIndex, colIndex) =>
          // `${ActionTDClasses} ${row?.deleted_at || row?.is_refund || row?.is_reversed ? "bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50" : ""}`,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ]
    : [
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "received_date",
        //   text: "Received Date",
        //   sort: true,
        //   sortCaret,
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "transaction_date",
          text: "Transaction Date",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: cn(
            THClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          classes: cn(
            TDClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          dataField: "contact",
          text: `${getModuleNamingBySlug(
            organizationData?.organizationData,
            "contacts",
            "Customer",
          )}`,
        },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "sub_asset",
        //   text: "Sub Asset",
        // },

        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "receipt_number",
          text: "Receipt Number",
          sort: true,
          sortCaret,
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "invoice_number",
          text: "Invoice Number",
          sort: true,
          sortCaret,
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "file_note",
          text: LawyerConditon(organizationData)
            ? "Matter Reference"
            : "File Note",
        },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "payment_method",
        //   text: "Payment Method",
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "amount",
          text: "Amount (Inc)",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "remaining_balance",
          text: "Remaining Balance",
        },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "amount_exc",
        //   text: "Amount (Exc)",
        // },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "tax_amount",
        //   text: "Tax",
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "status",
          text: "Status",
        },
      ];

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandReceipt expandData={row?.receiptData} />
      </>
    ),
    onlyOneExpanding: false,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  useEffect(() => {
    if (!expandList) {
      navigate(
        `?limit=${limit ? limit : defaultLimitPagination}&page=${
          page ? page : 1
        }&search=${searchParam ? searchParam : ""}&sort_column=${
          sortField ? sortField : ""
        }&sort_order=${sortOrder ? sortOrder : ""}&from=${
          moment(selectedDateRange?.from).format("DD-MM-YYYY")
            ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
            : ""
        }&to=${
          moment(selectedDateRange?.to).format("DD-MM-YYYY")
            ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
            : ""
        }`,
        {
          replace: true,
        },
      );
    }
  }, [
    expandList,
    navigate,
    limit,
    searchParam,
    page,
    sortField,
    sortOrder,
    selectedDateRange?.from,
    selectedDateRange?.to,
  ]);

  useEffect(() => {
    fetchReceipts();
  }, [fetchReceipts]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchReceipts(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchReceipts(limit, page);
  };

  const ReceiptItemList = (receipt, data) => {
    return data?.map(
      (item) =>
        item.remaining_balance !== 0 && {
          ...item,
          value: item?.id,
          label: `${receipt?.receipt_number} ${
            receipt?.invoice_number ? ` - ${receipt?.invoice_number}` : ""
          } ${
            item.remaining_balance
              ? ` ($${formatNumber(Number(item.remaining_balance))})`
              : ""
          }`,
        },
    );
  };

  return (
    <>
      <MainBody
        search={!expandList}
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        mainTitle={"Receipts / Deposit Records"}
        actionContent={
          !expandList && (
            <div className="flex items-center gap-3 flex-wrap">
              <CalendarDatePicker
                date={selectedDateRange}
                onDateSelect={setSelectedDateRange}
                variant="outline"
                align={isBigDesktop ? "end" : "start"}
                disabledDate={(date) => date > new Date()}
              />
              <CommonFilters
                trustId={trustId}
                contact={true}
                setContactId={setContactId}
                contactId={contactId}
                vendor={true}
                setVendorId={setVendorId}
                vendorId={vendorId}
                asset={true}
                setAssetId={setAssetId}
                assetId={assetId}
                subAsset={true}
                setSubAssetId={setSubAssetId}
                subAssetId={subAssetId}
                contract={true}
                setContractId={setContractId}
                contractId={contractId}
                reversed={true}
                reversedId={reversedId}
                setReversedId={setReversedId}
                refund={true}
                refundId={refundId}
                setRefundId={setRefundId}
                disposed={true}
                disposedId={disposedId}
                setDisposedId={setDisposedId}
              />
              <UploadReceipt
                fetchData={() => fetchReceipts(limit, page)}
                trustId={trustId}
                ButtonName={"Import"}
                setLoading={setLoading}
              />
              {/* Add Receipt */}
              <ResponsiveDrawerForm
                description={""}
                title={"Add Receipt(s)"}
                handleOpen={() => {}}
                handleClose={() => {}}
                buttonText={
                  <div className="flex items-center gap-1">
                    <LucidePlusCircle size={18} />
                    <span>Add Receipt</span>
                  </div>
                }
                open={showAddEditReceipt}
                buttonClassName={""}
                setOpen={setShowAddEditReceipt}
                className={"md:max-w-[95vw] md:max-h-[95vh]"}
                mobileCancelHidden={true}
                write={true}
              >
                <AddEditReceipt
                  toggleShowAddEditReceipt={toggleShowAddEditReceipt}
                  id={receiptId}
                  trustId={trustId}
                  receiptLastDate={receiptLastDate}
                  fetchReceiptData={() => fetchReceipts(limit, page)}
                />
              </ResponsiveDrawerForm>
            </div>
          )
        }
        loading={loading}
        mainClassName="w-[calc(100%-3rem)]"
        expandList={expandList}
      >
        <div className="custom-table">
          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              remote
              data={receipts}
              columns={columns}
              expandRow={expandRow}
              onTableChange={handleTableChange}
              rowClasses={(row) => {
                if (row?.is_reversed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_refund) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_disposed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.archived) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                return TRClasses;
              }}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
          {showUndo && (
            <Confirmation
              title={"Undo Receipt"}
              open={showUndo}
              setOpen={setShowUndo}
              toggleShow={() => {
                toggleShowUndo();
              }}
              className="sm:max-w-fit"
              message={
                <>
                  Are your sure you want to undo this receipt?
                  <br />
                  This will reverse the beneficial interest journal entry and
                  receipts journal entry if any.
                </>
              }
              okAction={async () => {
                await handleReceiptUndo();
              }}
              loading={loading}
              cancelAction={() => {
                toggleShowUndo();
              }}
            />
          )}

          {showRefund && (
            <Confirmation
              title={"Refund Receipt"}
              open={showRefund}
              setOpen={setShowRefund}
              toggleShow={() => {
                toggleShowRefund();
              }}
              className="sm:max-w-fit"
              message={
                <Formik
                  innerRef={formikRef}
                  initialValues={{
                    refund_date: new Date(),
                    refund_amount: "",
                    remaining_balance:
                      receiptItem?.receipt_detail?.length > 1
                        ? ""
                        : receiptItem?.receipt_detail?.length !== 0
                          ? receiptItem?.receipt_detail[0]?.remaining_balance
                          : "",
                    receipt_detail_id:
                      receiptItem?.receipt_detail?.length > 1
                        ? ""
                        : receiptItem?.receipt_detail?.length !== 0
                          ? receiptItem?.receipt_detail[0]?.id
                          : "",
                  }}
                  enableReinitialize
                  onSubmit={(values) => handleReceiptRefund("1", values)}
                  validateOnBlur={true}
                  validateOnChange={true}
                  validationSchema={receiptRefundSchema}
                >
                  {({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    isValid,
                    setTouched,
                    validateField,
                  }) => (
                    <>
                      <div className="flex items-center justify-between">
                        <div className="gap-2 text-left mb-4 ">
                          <Label htmlFor="refund_date">
                            <CustomLabelText
                              required={true}
                              labelText="Refund Date"
                            />
                          </Label>
                          <DateInputPicker
                            date={
                              values?.refund_date
                                ? values?.refund_date
                                : new Date()
                            }
                            onSelect={(e) => {
                              setFieldValue("refund_date", e);
                            }}
                            className={"w-[200px] text-left mt-2"}
                            inputClassName="w-full"
                            icon={true}
                            disabledDate={{ after: new Date() }}
                          />
                        </div>
                        <Button
                          className="w-fit"
                          onClick={() => toggleShowRefundHistory()}
                        >
                          History
                        </Button>
                      </div>

                      {receiptItem?.receipt_detail?.length > 1 ? (
                        <>
                          <div className="grid gap-2 text-left mb-4">
                            <Label htmlFor="type">
                              <CustomLabelText
                                required={true}
                                labelText="Receipt Detail"
                                errorField={errors?.receipt_detail_id}
                                bottomAlign={true}
                              />
                            </Label>
                            <div className="relative">
                              <SearchSelect
                                frameworks={ReceiptItemList(
                                  receiptItem,
                                  receiptItem?.receipt_detail,
                                )}
                                optionType={"Receipt Detail"}
                                handleSelect={(e) => {
                                  let receiptItemData = ReceiptItemList(
                                    receiptItem,
                                    receiptItem?.receipt_detail,
                                  )?.find((itemData) => itemData?.id === e);
                                  setFieldValue("receipt_detail_id", e);
                                  setFieldValue(
                                    "remaining_balance",
                                    receiptItemData?.remaining_balance,
                                  );
                                }}
                                handleBlur={handleBlur}
                                className={
                                  errors?.receipt_detail_id &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                initialValue={values?.receipt_detail_id}
                                disabled={false}
                              />
                            </div>
                          </div>

                          {values?.receipt_detail_id && (
                            <div className="gap-2 text-left mb-4 flex items-center justify-between">
                              <div className="font-bold">
                                Refundable Amount:
                                <span className="bg-red-500 text-white text-sm px-2 rounded-md ml-1">
                                  ${" "}
                                  {receiptItem?.receipt_detail?.length > 1
                                    ? formatNumber(
                                        Number(values?.remaining_balance),
                                      )
                                    : formatNumber(Number(receiptItem?.amount))}
                                </span>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="gap-2 text-left mb-4 flex items-center justify-between">
                          <div className="font-bold">
                            Refundable Amount:
                            <span className="bg-red-500 text-white text-sm px-2 rounded-md ml-1">
                              ${" "}
                              {receiptItem?.receipt_detail?.length > 1
                                ? formatNumber(
                                    Number(values?.remaining_balance),
                                  )
                                : formatNumber(Number(receiptItem?.amount))}
                            </span>
                          </div>
                        </div>
                      )}

                      <div className="grid gap-2 text-left mb-4">
                        <Label htmlFor="refund_amount">
                          <CustomLabelText
                            required={false}
                            labelText="Refund Amount"
                            errorField={errors?.refund_amount}
                          />
                        </Label>

                        <NumericFormat
                          type="text"
                          name="refund_amount"
                          value={values?.refund_amount}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          decimalScale={2}
                          allowNegative={false}
                          thousandSeparator={true}
                          isAllowed={(values) => MaxLimit(values)}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          className={
                            errors?.refund_amount
                              ? `${cn(
                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                )} focus-visible:ring-red-500 border-red-500`
                              : cn(
                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                )
                          }
                        />
                      </div>

                      <div className="grid gap-2 text-left mb-4">
                        <div className="font-bold">
                          Remaining Balance:
                          <span className="bg-green-500 text-white text-sm px-2 rounded-md ml-1">
                            ${" "}
                            {formatNumber(
                              Number(receiptItem?.amount.replace(/,/g, "")) -
                                Number(values?.refund_amount.replace(/,/g, "")),
                            )}
                          </span>
                        </div>
                      </div>

                      <div>Are your sure you want to refund this amount?</div>
                    </>
                  )}
                </Formik>
              }
              // okAction={async () => {
              //   await handleReceiptRefund("1");
              // }}
              okAction={async () => {
                if (formikRef.current) {
                  formikRef.current.handleSubmit();
                }
              }}
              loading={loading}
              cancelAction={() => {
                toggleShowRefund();
              }}
            />
          )}

          {showUse && (
            <Confirmation
              title={"Allocate Receipt"}
              open={showUse}
              setOpen={setShowUse}
              toggleShow={() => {
                toggleShowUse();
              }}
              className="sm:max-w-fit"
              message={
                <>
                  {/* <div className="grid gap-2 text-left mb-4">
                    <Label htmlFor="allocate-date">
                      <CustomLabelText
                        required={true}
                        labelText="Allocate Date"
                      />
                    </Label>
                    <DateInputPicker
                      date={allocateDate ? allocateDate : new Date()}
                      onSelect={(e) => {
                        setAllocateDate(e);
                      }}
                      className={"w-[200px] text-left"}
                      inputClassName="w-full"
                      icon={true}
                      disabledDate={{ after: new Date() }}
                    />
                  </div>{" "} */}
                  <div className="gap-2 text-left mb-4 flex items-center justify-between">
                    <div className="font-bold">
                      Allocate Amount: $
                      <span>{formatNumber(Number(receiptItem?.amount))}</span>
                    </div>
                  </div>
                  <div>
                    Are you sure you want to proceed with this allocation to the{" "}
                    {getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "Vendor",
                    )?.toLowerCase()}{" "}
                    on the transaction date?
                  </div>
                </>
              }
              okAction={async () => {
                await handleReceiptRefund("0");
              }}
              loading={loading}
              cancelAction={() => {
                toggleShowUse();
              }}
            />
          )}

          <ResponsiveDrawerForm
            description={""}
            title={"Send Email"}
            handleOpen={() => {}}
            handleClose={() => {}}
            className={"sm:max-w-[50vw] max:min-w-screen"}
            open={showSendEmail}
            buttonClassName={""}
            setOpen={setShowSendEmail}
            read={true}
            mobileCancelHidden={true}
          >
            <>
              <div className="overflow-y-auto overflow-x-hidden max-h-[78vh] md:p-0 p-4">
                <AdditionalDocumentEmailModal
                  defaultContent={
                    <>
                      <div className="text-center">
                        Are you sure you want to email this receipt to the
                        beneficiary for the receipt?
                      </div>
                      <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
                        <Button
                          type="submit"
                          data-dismiss="modal"
                          onClick={() => {
                            receiptId && PostDefaultMail(receiptId);
                          }}
                        >
                          Yes
                        </Button>
                        <Button
                          type="Button"
                          className="ml-3"
                          variant="secondary"
                          onClick={() => {
                            handleSendEmail();
                          }}
                        >
                          No
                        </Button>
                      </div>
                    </>
                  }
                  handleSubmit={handleSubmit}
                  setFiles={setFiles}
                  files={files}
                  toggleCancel={handleSendEmail}
                  // handleEditorChange={handleEditorChange}
                  // editorState={editorState}
                  mailData={mailData}
                  type={"receipt"}
                  loading={loading}
                />
              </div>
            </>
          </ResponsiveDrawerForm>

          <Confirmation
            title={"Revert Receipt"}
            open={showDelete}
            setOpen={setShowDelete}
            toggleShow={() => {
              toggleShowDelete();
            }}
            className="sm:max-w-1/2"
            message={"Are you sure you want to revert?"}
            okAction={async () => {
              handleReceiptDelete();
              toggleShowDelete();
              fetchReceipts();
            }}
            cancelAction={() => {
              setReceiptId(null);
              setShowDelete(!showDelete);
            }}
          />

          <ResponsiveDrawerForm
            description={""}
            title={"Refund History"}
            handleOpen={() => {}}
            handleClose={() => {}}
            className={"sm:max-w-[50vw] max:min-w-screen"}
            open={showRefundHistory}
            buttonClassName={""}
            setOpen={setShowRefundHistory}
            read={true}
            mobileCancelHidden={true}
          >
            <>
              <RefundReceiptHistory receiptId={receiptId} />
            </>
          </ResponsiveDrawerForm>
        </div>
      </MainBody>
    </>
  );
};

export default Receipts;
